import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import MobileMenu from './MobileMenu';
import { getHeadersAndCategory, getChatHistoryAPI, updateChatHistoryAPI, searchUserCreateAPI } from '../../../serverApi/server';
import Skeleton from '../../../pages/skeleton/Skeleton';
import { FaRocketchat, FaPaperPlane } from "react-icons/fa";
import { BsFillChatDotsFill } from "react-icons/bs";
import { MdDeleteForever } from "react-icons/md";
import { GrAttachment } from "react-icons/gr";
// import CustomerChat from '../../../pages/StalbansChat/CustomerChat'
import { getFormattedDateLabel, getCookie } from '../../Helper/Helpers'


const sessionId =
  localStorage.getItem("chatSession") ||
  (() => {
    const array = new Uint32Array(4);
    window.crypto.getRandomValues(array);
    const id = Array.from(array, dec => dec.toString(36)).join('');
    localStorage.setItem("chatSession", id);
    return id;
  })();


const NewMenu = () => {
  const navigate = useNavigate();
  const [horizLine, setHorizLine] = useState(null);

  const subMenuAnimate =  {
    enter: {
      opacity: 1,
      rotateX: 0,
      transition: {
        duration: 0.3,
      },
      display: 'block',
    },
    exit: {
      opacity: 0,
      rotateX: -15,
      transition: {
        duration: 0.3,
      },
      display: 'none',
    }
  }

  const [headers, setHeaders] = useState([]);

  const fetchHeader = async () => {
    try {
      const getHeaderCategory = await getHeadersAndCategory();
      if (getHeaderCategory.client_status_code === 200) {
      setHeaders(getHeaderCategory.all_header_menus_details);
      setLoadingTime(false);
      }
    } catch (error) {
      console.error("Error Fetching Header:", error);
    }
  };

  useEffect(() => {
    fetchHeader();
  }, [])

  const [hoverID, setHoverID] = useState(null);

  const toggleHoverMenu = (id) => {
    setHoverID(id);
  }

  const dropdownRef = useRef(null);
  const [clickedID, setClickedID] = useState(null);

  const handleToggle = (id) => {
    const newID = clickedID === id ? null : id;
    setClickedID(newID);
    toggleHoverMenu(newID);
  };

  const [loadingTime, setLoadingTime] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [allMessages, setAllMessages] = useState({});
  const [message, setMessage] = useState("");
  const [notificationCount, setNotificationCount] = useState(0)
  const socket = useRef(null);
  const scrollRef = useRef(null);
  const userId = getCookie('_puisap');

  // console.log('\n userId=============>:', userId)
  // useEffect(() => {
  //   let reconnectTimeout = null;
  //   let shouldReconnect = true;
  //   const ws = new WebSocket(`ws://127.0.0.1:8001/ws/chat/${sessionId}/`);
  //   socket.current = ws;
  //   const connectWebSocket = () => {
  //     ws.onmessage = (e) => {
  //       const data = JSON.parse(e.data);
  //       // console.log('\n data_user_unread_count:', data.user_unread_count)
  //       console.log('\n data ==============>', data)
  //       if (data.session_id !== sessionId) return;
  //       if (isOpen === true) {
  //         setNotificationCount(0);
  //       } else {
  //         setNotificationCount(data.user_unread_count)
  //       }
  //       const now = new Date();
  //       const options = {
  //         timeZone: 'America/New_York',
  //         month: '2-digit',
  //         day: '2-digit',
  //         year: '2-digit',
  //       };
  //       const estDate = new Intl.DateTimeFormat('en-US', options).format(now);
  //       data.created_at = now.toISOString().replace('Z', '+00:00');
  //       setAllMessages((prev) => {
  //         const updated = { ...prev };
  //         if (updated[estDate]) {
  //           const isDuplicate = updated[estDate].some(
  //             (msg) => msg.message === data.message && msg.sender === data.sender && msg.timestamp === data.timestamp
  //           );
  //           if (!isDuplicate) {
  //             updated[estDate] = [...updated[estDate], data];
  //           }
  //         } else {
  //           updated[estDate] = [data];
  //         }
  //         return updated;
  //       });
  //     };
  //     ws.onclose = (e) => {
  //       console.warn("WebSocket closed ❌", e);
  //       if (shouldReconnect) {
  //         // console.log("Attempting to reconnect in 3 seconds...");
  //         reconnectTimeout = setTimeout(connectWebSocket, 3000); // Retry after 3s
  //       }
  //     };
  //     ws.onerror = (e) => {
  //       console.error("WebSocket error 💥", e);
  //       ws.close(); // Force close to trigger reconnect
  //     };
  //     // console.log('\n isOpen=============>:', isOpen)
  //   };
  //   const getChatMessageHistory = async (sessionId) => {
  //     const res = await getChatHistoryAPI(sessionId);
  //     console.log('\n res =====================--------------->res:', res)
  //     if (res.data.client_status_code === 200) {
  //       setAllMessages(res.data.chat_message_serializer);
  //       setNotificationCount(res.data.user_unread_count)
  //     }
  //     if (isOpen === true) {
  //       setNotificationCount(0);
  //     }
  //   };
  //   getChatMessageHistory(sessionId, isOpen);
  //   connectWebSocket();
  //   const pingInterval = setInterval(() => {
  //     if (socket.current?.readyState === WebSocket.OPEN) {
  //       socket.current.send(JSON.stringify({ type: 'ping' }));
  //     }
  //   }, 3000);
  //   return () => {
  //     shouldReconnect = false;
  //     clearInterval(pingInterval);
  //     clearTimeout(reconnectTimeout);
  //     socket.current?.close();
  //   };
  // }, [isOpen]);


  const updateChatHistoryMessage = async () => {
    var updateChatHistoryAPIResponse = await updateChatHistoryAPI(sessionId);
    if (updateChatHistoryAPIResponse.data.client_status_code === 200) {
      setNotificationCount(0)
    }
  }

  useEffect(() => {
    let reconnectTimeout = null;
    let pingInterval = null;
    let shouldReconnect = true;

    const connectWebSocket = () => {
      const ws = new WebSocket(`wss://www.stalbansprinting.com/ws/chat/${sessionId}/`);
      socket.current = ws;

      ws.onopen = () => {
        console.log("WebSocket connected ✅");
      };

      ws.onmessage = async (e) => {
        const data = JSON.parse(e.data);
        if (data.type === "message_deleted") {
          const messageId = data.message_id;
          setAllMessages((prev) => {
            const updated = { ...prev };
            for (const date in updated) {
              updated[date] = updated[date].filter((msg) => msg.id !== messageId);
            }
            return updated;
          });
          return;
        }

        if (data.session_id !== sessionId) return;
        setNotificationCount(data.user_unread_count);
        const now = new Date();
        const options = {
          timeZone: "America/New_York",
          month: "2-digit",
          day: "2-digit",
          year: "2-digit",
        };
        const estDate = new Intl.DateTimeFormat("en-US", options).format(now);
        data.created_at = now.toISOString().replace("Z", "+00:00");

        setAllMessages((prev) => {
          const updated = { ...prev };
          if (updated[estDate]) {
            const isDuplicate = updated[estDate].some(
              (msg) =>
                msg.message === data.message &&
                msg.sender === data.sender &&
                msg.timestamp === data.timestamp
            );
            if (!isDuplicate) {
              updated[estDate] = [...updated[estDate], data];
            }
          } else {
            updated[estDate] = [data];
          }
          return updated;
        });
      };

      ws.onclose = (e) => {
        console.warn("WebSocket closed ❌", e);
        if (shouldReconnect) {
          reconnectTimeout = setTimeout(() => {
            console.log("Reconnecting WebSocket...");
            connectWebSocket();
          }, 3000);
        }
      };

      ws.onerror = (e) => {
        console.error("WebSocket error 💥", e);
        ws.close();
      };
    };

    const getChatMessageHistory = async () => {
      const res = await getChatHistoryAPI(sessionId);
      if (res.data.client_status_code === 200) {
        setAllMessages(res.data.chat_message_serializer);
        setNotificationCount(res.data.user_unread_count);
      }
      if (isOpen) {
        await updateChatHistoryMessage(sessionId);
      }
    };

    getChatMessageHistory();
    connectWebSocket();

    pingInterval = setInterval(() => {
      if (socket.current?.readyState === WebSocket.OPEN) {
        socket.current.send(JSON.stringify({ type: "ping" }));
      }
    }, 3000);

    return () => {
      shouldReconnect = false;
      clearInterval(pingInterval);
      clearTimeout(reconnectTimeout);
      // socket.current?.close();
    };
  }, [isOpen, sessionId]);

  const sendMessage = async () => {
    if (message.trim()) {
      socket.current.send(JSON.stringify({ message: message, sender: "user", user_id: userId }));
      setMessage("");
      await updateChatHistoryMessage(sessionId);
    }
  };

  const handleDeleteMessage = (seletedMessage) => {
    if (!seletedMessage.id) return;
    try {
      socket.current.send(
        JSON.stringify({
          type: "delete",
          message_id: seletedMessage.id,
          sender: "user",
        })
      );
    } catch (err) {
      console.error("WebSocket delete error:", err);
    }
  }

  useEffect(() => {
    if (isOpen && scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [allMessages, isOpen]);

  const getProductImages = async (additionalName, categoryId) => {
    await searchUserCreateAPI(userId, categoryId, null)
    navigate(additionalName);
  }

  return (
    <div className='w-full px-5 sm:px-[3vw] border-b-[1px]'>
      <nav className='hidden custom-991:flex justify-between'>
        <ul className='flex justify-center w-full'>
          {loadingTime ? (
            <div className='flex gap-8 h-14 items-center'>
              <Skeleton width='60px' height='22px' marginBottom='0px'/>
              <Skeleton width='100px' height='22px' marginBottom='0px'/>
              <Skeleton width='60px' height='22px' marginBottom='0px'/>
              <Skeleton width='100px' height='22px' marginBottom='0px'/>
              <Skeleton width='60px' height='22px' marginBottom='0px'/>
              <Skeleton width='100px' height='22px' marginBottom='0px'/>
              <Skeleton width='60px' height='22px' marginBottom='0px'/>
              <Skeleton width='100px' height='22px' marginBottom='0px'/>
              <Skeleton width='60px' height='22px' marginBottom='0px'/>
            </div>) 
          : 
            <>
              <li onClick={() => setHorizLine('home')} className='cursor-pointer'>
                <div onClick={() => navigate('/')} className='SelectedOne group h-full flex items-center px-2 lg:px-3 duration-200 py-2 lg:py-4 hover:bg-orange-200'>
                  <div className='flex flex-col justify-center items-center text-center gap-1'>
                    Home
                    <hr className={`${horizLine === 'home' ? 'opacity-100' : 'opacity-0'} w-2/4 activeLine border-none h-[1px] bg-gray-600`}/>
                  </div>
                </div>
              </li>
              {headers && headers.map((header) => (
              <motion.li
                onHoverStart={() => toggleHoverMenu(header.header_menu_id)}
                onHoverEnd={() => toggleHoverMenu(null)}
                onClick={() => handleToggle(header.header_menu_id)}
                ref={dropdownRef}
                key={header.header_menu_id}
                className='group/link'
              >
                <div  className='SelectedOne cursor-pointer group h-full flex items-center px-2 lg:px-3 duration-200 py-2 lg:py-4 hover:bg-orange-200'>
                  <div className='flex flex-col justify-center items-center text-center gap-1'>
                    {header.header_menu}
                    <hr className={`${horizLine === header.header_menu_id ? 'opacity-100' : 'opacity-0'} w-2/4 activeLine border-none h-[1px] bg-gray-600`}/>
                  </div>
                </div> 
                
                <motion.div 
                  className='sub-menu'
                  initial='exit'
                  animate={hoverID === header.header_menu_id ? 'enter' : 'exit'}
                  variants={subMenuAnimate}
                >
                  <div 
                    style={{ rowGap: '0.0rem' }}
                    className={`grid gap-x-6 gap-y-2 ${header.header_menu === 'Celebrations' ? 'grid-cols-2' : 'grid-cols-3'}`}
                  >
                    {header.categories && header.categories.filter(categ => categ.is_active === true && categ.category !== 'Our Allied Companies' && categ.category !== 'Testing').map((categ) => ( 
                      <div key={categ.id} className='flex flex-col justify-center cursor-pointer' onClick={() => setHorizLine(header.header_menu_id)}>
                        <div onClick={() => {
                          if (categ.additional_name === 'website_designing') {
                          	window.open('https://craftcominc.com', '_blank');
                          } else {
                          	getProductImages(categ.additional_name, categ.id);

                          }
                          toggleHoverMenu(null);
                          }} className='px-2 py-1 rounded hover:text-orange-700 hover:bg-neutral-100 duration-00'>
                          {categ.category}
                        </div>
                      </div>
                    ))}
                  </div>
                </motion.div>
              </motion.li>
              ))}

              {/* <li onClick={() => setHorizLine('about')} className='cursor-pointer'>
                <div onClick={() => navigate('/about')} className='SelectedOne group h-full flex items-center px-2 lg:px-3 duration-200 lg:py-4 hover:bg-orange-200'>
                  <div className='flex flex-col justify-center items-center text-center gap-1'>
                    About Us
                    <hr className={`${horizLine === 'about' ? 'opacity-100' : 'opacity-0'} w-2/4 activeLine border-none h-[1px] bg-gray-600`}/>
                  </div>
                </div>
              </li> */}
              <li onClick={() => setHorizLine('contact_us')} className='cursor-pointer'>
                <div onClick={() => navigate('/contact_us')} className='SelectedOne group h-full flex items-center px-2 lg:px-3 duration-200 py-2 lg:py-4 hover:bg-orange-200'>
                  <div className='flex flex-col justify-center items-center text-center gap-1'>
                    Contact Us
                    <hr className={`${horizLine === 'contact_us' ? 'opacity-100' : 'opacity-0'} w-2/4 activeLine border-none h-[1px] bg-gray-600`}/>
                  </div>
                </div>
              </li>

              <li onClick={() => setHorizLine('/soulscript')} className='cursor-pointer'>
                <div onClick={() => navigate('/soulscript')} className='SelectedOne group h-full flex items-center px-2 lg:px-3 duration-200 py-2 lg:py-4 hover:bg-orange-200'>
                  <div className='flex flex-col justify-center items-center text-center gap-1'>
                    Soulscript
                    <hr className={`${horizLine === 'soulscript' ? 'opacity-100' : 'opacity-0'} w-2/4 activeLine border-none h-[1px] bg-gray-600`}/>
                  </div>
                </div>
              </li>
              
            </>
          }
        </ul>
      </nav>
      <div className='custom-991:hidden'> 
        <MobileMenu />
      </div>
      {isOpen && (
        <div
          className="fixed bottom-24 right-4 mb-[20px] sm:right-12 md:right-16 w-[90%] sm:w-[22rem] max-w-[400px] bg-white border border-gray-200 rounded-2xl shadow-2xl flex flex-col overflow-hidden"
          style={{ zIndex: 9999 }}
        >
          <div className="bg-orange-500 text-white flex justify-between items-center px-4 py-3">
            <div className="font-semibold text-sm">Virtual Shopping Assistant<br /><p className="text-[11px] font-normal">Live chat is available between 10 AM to 7 PM EST</p></div>
            <button
              onClick={() => setIsOpen(false)}
              className="text-white hover:text-red-300 text-lg"
            >
              ✕
            </button>
          </div>
          <div ref={scrollRef} 
            className="flex-1 px-4 py-2 space-y-2 overflow-y-auto text-sm max-h-[50vh] bg-white hide-scrollbar"
            >
            <div className="bg-gray-100 p-2 rounded-lg w-fit">
              👋 Hi there! <br />Welcome to St. Albans Digital Printing Inc.. I'm your virtual assistant, here to help you find what you need. How can I assist you today?
            </div>
            <div className="space-y-2">
            {Object.keys(allMessages).length === 0 ? (
                  <div className="text-center text-gray-500 py-4">No messages yet</div>
                  ) : (
                  Object.entries(allMessages).map(([date, messages]) => (
                      <div key={date}>
                      <div className="text-center text-xs text-gray-500 mb-2">
                          {getFormattedDateLabel(date)}
                      </div>
                      <div className="space-y-2">
                          {messages.map((msg, i) => {
                          const time = new Date(msg.timestamp || msg.created_at).toLocaleTimeString('en-US', {
                              hour: '2-digit',
                              minute: '2-digit',
                              hour12: true,
                              timeZone: 'America/New_York',
                          });
                          return (

                              <div
                                key={msg.id || i}
                                className={`relative group px-4 py-2 text-sm w-fit max-w-[80%] break-words whitespace-pre-wrap transition rounded-[15px] ${
                                    msg.sender === 'user'
                                    ? 'bg-orange-500 text-white self-end ml-auto'
                                    : 'bg-gray-200 text-black self-start mr-auto'
                                }`}
                              >
                                
                                <div>{msg.message}</div>
                                <div className="text-xs text-right opacity-70 mt-1">{time}</div>

                                {msg.sender === 'user' && (
                                  <MdDeleteForever 
                                    size={20}
                                    onClick={() => handleDeleteMessage(msg)}
                                    className="absolute cursor-pointer top-1 right-1 opacity-0 group-hover:opacity-100 text-white text-xs hover:text-red-300 transition"
                                  />
                                )}

                              </div>
                          );
                          })}
                      </div>
                      </div>
                  ))
              )}
            </div>
          </div>
          <div className="flex items-center border-t border-gray-200 px-4 py-3">
            <GrAttachment className="opacity-70" />
            <input
              type="text"
              placeholder="Write your message..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyDown={(e) => {
                  if (e.key === 'Enter' && message.trim()) {
                    sendMessage();
                  }
              }}
              className="ml-[10px] flex-1 text-sm outline-none placeholder-gray-400"
            />
            <button
              onClick={sendMessage}
              className="text-orange-500 hover:text-orange-600 ml-2"
            >
              <FaPaperPlane size={24} />
            </button>
          </div>
        </div>
      )}
      <div
        className="fixed bottom-8 right-8 sm:bottom-12 sm:right-12 md:bottom-16 md:right-16 z-50 bg-orange-500 text-white p-3 rounded-full shadow-lg cursor-pointer hover:bg-orange-700 transition"
        onClick={() => setIsOpen(!isOpen)}
      >
        <BsFillChatDotsFill size={20} />
        {notificationCount > 0 && 
          <div className="absolute -top-1 -right-1 bg-red-600 text-xs w-5 h-5 rounded-full flex items-center justify-center font-bold">
            {notificationCount}
          </div>
        }
      </div>
    </div>
  )
}

export default NewMenu;